import apiClient from "@/services/InvoiceapiClient";
export default {
  //<!-----------------------------set session to invoice api project api's-------------------------------->
  setSessionId(session_id, id) {
    var admin = id == 1 ? 1 : 0;
    apiClient.defaults.headers.common["token"] = session_id;
    apiClient.defaults.headers.common["admin"] = admin;
    return apiClient.get("/cookie.php");
  },
};
